import $ from 'jquery'

$(document).on('change', '.select-css', function(){
  window.location.href = this.value;
})
